import { EEventType } from './../../enums/EEventType';
import styles from './index.module.less';
import template from './index.art';
import OY from '../../types/OY';
import { IOYTabProps, IOYTabState } from './const';
import { jeact } from '../../decorators/jeact'

@jeact()
export default class OYTab extends OY<IOYTabProps, IOYTabState> {
  static displayName = 'OYTab';

  static defaultProps: Partial<IOYTabProps> = {
    tabs: []
  }

  public state: IOYTabState = {
    current: { name: '', key: '' }
  };

  $node = {
    head: $(),
    items: $(),
    content: $()
  }

  preValue: string[] = [];

  getDerivedStateFromProps(prop: IOYTabProps, state: IOYTabState) {
    const { tabs, value, defaultActiveKey } = prop;
    const val = value || defaultActiveKey;
    const current = tabs.find(va => va.key === val) || { ...tabs[0] }

    return { ...state, current }
  }

  render() {
    return template({ props: this.props, state: this.state, styles })
  }

  componentAfterRender() {
    const children = this.$parent.children()
    const child = children.filter(`[name=${this.state.current.key}]`);
    child.addClass(styles.active_content)
    this.$el.find('slot').replaceWith(children);
  }

  setNode(): void {
    this.$node = {
      head: this.$el.find(`.${styles.oy_tab_head}`),
      items: this.$el.find(`.${styles.oy_tab_head_item}`),
      content: this.$el.find(`.${styles.oy_tab_content}`)
    }
  }

  protected bindHeadClick() {
    this.$node.head.delegate(`.${styles.oy_tab_head_item}`, 'click', (ev: Event) => {
      const $element = $(ev.currentTarget!);
      if ($element.hasClass(styles.active)) {
        return;
      }
      const index = $element.data('index');
      const data = this.props.tabs[index];
      // 更新state
      this.state.current = { ...data };
      // 切换头部
      this.$node.items.removeClass(styles.active);
      $element.addClass(styles.active);
      // 切换content

      this.$node.content.children()
        .removeClass(styles.active_content)
        .filter(`[name=${data.key}]`)
        .addClass(styles.active_content)

      this.eventEmitter.emit(EEventType.onTabChange, data, index)
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/OYTab/index.ts